/**
 * Shopify Storefront API url
 */
export const STOREFRONT_API_URL = `https://${ process.env.GATSBY_SHOPIFY_STORE_URL }/api/${ process.env.GATSBY_SHOPIFY_API_VERSION }/graphql.json`;

/**
 * Shopify Storefront API access token
 */
export const STOREFRONT_API_ACCESS_TOKEN = process.env.GATSBY_STOREFRONT_ACCESS_TOKEN;

/**
 * Base url for Balance Body forms.
 */
export const BB_LOCATION_API_URL = process.env.GATSBY_BB_LOCATION_API_URL;

/**
 * Auth0 LogIn/LogOut urls
 */

// eslint-disable-next-line max-len
// export const LOGIN_URL = `${ process.env.GATSBY_AUTH0_URL }/authorize?response_type=token&client_id=${ process.env.GATSBY_AUTH0_CLIENT_ID }&redirect_uri=${ process.env.GATSBY_SITE_URL }/account`;
// eslint-disable-next-line max-len
// export const LOGOUT_URL = `${ process.env.GATSBY_AUTH0_URL }/v2/logout?client_id=${ process.env.GATSBY_AUTH0_CLIENT_ID }&returnTo=${ process.env.GATSBY_SITE_URL }`;
